// extracted by mini-css-extract-plugin
export default {"spacingInput":"HowCallYou_spacingInput__ra-N8"};